import { render, staticRenderFns } from "./AccountingSalaryDetail.vue?vue&type=template&id=4f6e4a24&"
import script from "./AccountingSalaryDetail.vue?vue&type=script&lang=js&"
export * from "./AccountingSalaryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports